import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {CheckboxComponent} from "./checkbox";
import {DotLoaderComponent} from "./dotLoader";
import {DropdownComponent} from "./dropdownNg2";
import {ComposeNumberComponent} from "./composeNumber";
import {iconComponent} from "./icon";
import {EncodeURIComponentPipe} from "./encodeURIComponentPipe";
import {KindDisplayPipe} from "./kindDisplayPipe";
import {NotificationsComponent} from "./notifications";
import {UtcDatePipe} from "./utcdateFilter";
import {InvestorNamePipe} from "./investorNamePipe";
import {SecurityNamePipe} from "./securityNamePipe";
import {ErrorLevelPipe} from "./errorLevelPipe";

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    declarations: [
        CheckboxComponent,
        DotLoaderComponent,
        DropdownComponent,
        iconComponent,
        ComposeNumberComponent,
        NotificationsComponent,
        EncodeURIComponentPipe,
        InvestorNamePipe,
        SecurityNamePipe,
        KindDisplayPipe,
        ErrorLevelPipe,
        UtcDatePipe
    ],
    exports: [
        CheckboxComponent,
        DotLoaderComponent,
        DropdownComponent,
        iconComponent,
        ComposeNumberComponent,
        NotificationsComponent,
        EncodeURIComponentPipe,
        InvestorNamePipe,
        SecurityNamePipe,
        KindDisplayPipe,
        ErrorLevelPipe,
        UtcDatePipe
    ]
})
export class ElementsModule {}



// WEBPACK FOOTER //
// ./_src/ui/elements/elementsModule.ts